import React, { useState } from "react";
import styled from "@emotion/styled";
import BackHeader from "@components/header/BackHeader";
import BasicButton from "@components/button/BasicButton";
import { useTheme } from "@emotion/react";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import { Collapse } from "antd";
import Image from "@components/item/Image";
import { useApiRequest } from "@utils/ApiRequest";
import { useQuery } from "@tanstack/react-query";

const FaqContainer = styled.div({
  display: "flex",
  flexDirection: "column",
});

const FilterWrapper = styled(Swiper)({
  display: "flex",
  gap: "0.8rem",
  maxWidth: "520px",
  width: "100%",

  ".swiper-slide": {
    width: "fit-content !important",
    marginRight: "1rem",
  },
});

const CollapseContainer = styled(Collapse)(({ theme }) => ({
  backgroundColor: "transparent",
  fontFamily: "Pretendard ,Sans-serif",
  borderRadius: "0",
  boxShadow: "none",
  padding: "1rem 0",

  ".ant-collapse-header": {
    padding: "2rem !important",
  },
  ".ant-collapse-content-box": {
    padding: "2rem !important",
    color: theme.color.gray,
    lineHeight: "2.4rem",
  },
  ".ant-collapse-item": {
    borderBottom: `1px solid ${theme.color.border_gray} !important`,
  },
}));

const Faq = () => {
  const theme = useTheme();
  const [active, setActive] = useState<string>("OP");
  const lang = window.localStorage.getItem("language");

  const { getFaqCategory, getFaqList } = useApiRequest();

  const { data: faqCategory } = useQuery({
    queryKey: ["faqCategory"],
    queryFn: getFaqCategory,
  });

  const { data: faqList } = useQuery({
    queryKey: ["faqList", active],
    queryFn: () => getFaqList(active),
  });

  const faqListItem = faqList?.map((item: any, index: number) => ({
    key: index.toString() + active,
    label:
      lang === "en" && item.question_en ? item.question_en : item.question_ko,
    children: (
      <span>
        {lang === "en" && item.answer_en ? item.answer_en : item.answer_ko}
      </span>
    ),
  }));

  const handleTabChange = (id: string) => {
    setActive(id);
  };

  return (
    <FaqContainer>
      <BackHeader title="FAQ" />

      <div
        style={{
          padding: "0 2rem",
        }}>
        <FilterWrapper slidesPerView={"auto"}>
          {faqCategory?.map(
            ({
              code,
              name_ko,
              name_en,
              index,
            }: {
              code: string;
              name_ko: string;
              name_en: string;
              index: number;
            }) => (
              <SwiperSlide
                key={index}
                style={{
                  display: "flex",
                }}>
                <BasicButton
                  title={lang === "en" && name_en ? name_en : name_ko}
                  height="3.2rem"
                  radius="0.4rem"
                  onClick={() => handleTabChange(code)}
                  outlined={code !== active}
                  borderColor={theme.color.light_gray}
                  padding="0.8rem 1.2rem"
                  fit
                />
              </SwiperSlide>
            ),
          )}
        </FilterWrapper>
      </div>

      <CollapseContainer
        items={faqListItem}
        bordered={false}
        expandIconPosition={"end"}
        expandIcon={({ isActive }) =>
          isActive ? (
            <Image
              src={theme.image.arrow_up.default}
              width="2rem"
              height="2rem"
            />
          ) : (
            <Image
              src={theme.image.arrow_down.default}
              width="2rem"
              height="2rem"
            />
          )
        }
      />
    </FaqContainer>
  );
};

export default Faq;
